// extracted by mini-css-extract-plugin
export default {"containerWrapper":"AdminContainer_containerWrapper__7oVwd","content":"AdminContainer_content__wfuRk","children":"AdminContainer_children__bOKZ7"};